import axios from 'axios';
import { BookingDetailsDTO } from './bookingService';

interface BookingUpdateRequest {
  bookingDescription?: string;
  arrivalDate?: string;
  departureDate?: string;
  totalPrice?: number;
  chaletType?: "big" | "small";
  chaletId?: number;
}

interface UpdateBookingResponse {
  updatedBooking: BookingDetailsDTO;
}

const apiUrl = process.env.REACT_APP_API_URL;

const updateBooking = async (bookingId: number, updateRequest: BookingUpdateRequest): Promise<UpdateBookingResponse> => {
  const token = localStorage.getItem('accessToken');
  try {
    const response = await axios.post<UpdateBookingResponse>(`${apiUrl}/Booking/updateBooking`, updateRequest, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      params: { bookingId }
    });
    return response.data;
  } catch (error: any) {
    throw new Error(`Error updating booking: ${error.message}`);
  }
};

export default updateBooking;